import _typeof from "@babel/runtime/helpers/typeof";

var isMotionValue = function isMotionValue(value) {
  return value !== null && _typeof(value) === "object" && value.getVelocity;
};

export { isMotionValue };